<template>
	<div class="wrapper">
		<div class="use" v-if="status===0 || status===2">
			<div class="head_tip">客服热线 0571-85199986(服务时间8:30-20:00)</div>
			<div class="head">
				<header>
					<div class="lt">
						<p>{{txt}}</p>
						<span>链接有效期至:{{expiredDate}}</span>
					</div>
					<img :src="imgUrl" :alt="txt">
					<span class="ico">电子券</span>
				</header>
			</div>
			<div class="body">
				<header>
					您已选择充值【{{txt}}】，本产品为虚拟产品，请务必核对账户正确，充值后不可撤销且无法退返，直充券码：充值结果请至品牌运营商后台核查，线下商户：请按照券码使用规则使用。
				</header>
				<!-- 多账号类型 -->
				<div class="bd" v-if="typeCode == 2">
					<h1>充值账号</h1>
					<div class="txt"><span>账号</span><input placeholder="请输入账号" v-model="accountNo"></div>
					<div class="txt"><span>再次输入</span><input placeholder="请再次输入账号" v-model="reAccountNo"></div>
				</div>
				<!-- 手机号直充 -->
				<div class="bd" v-if="typeCode == 1">
					<h1>充值账号</h1>
					<div class="txt"><span>账号</span><input type="number" placeholder="请输入充值账号" v-model="accountNo"></div>
					<div class="form">
						<div class="code">
							<span>验证码</span>
							<input type="text" placeholder="请输入验证码" v-model="verifyCode">
						</div>
						<button v-if="verifyShow" @click="verifyCodeGet(accountNo)">获取验证码</button>
						<em v-if="!verifyShow">{{verifyTime}}s</em>
					</div>
				</div>
				<!-- 卡密类型 -->
				<!-- 未绑定手机号，绑定手机号 -->
				<div class="bd" v-if="typeCode==3 && !typeAccount">
					<h1>充值账号</h1>
					<div class="txt"><span>账号</span><input type="number" placeholder="请输入充值账号" v-model="accountNo"></div>
					<div class="form">
						<div class="code">
							<span>验证码</span>
							<input type="text" placeholder="请输入验证码" v-model="verifyCode">
						</div>
						<button v-if="verifyShow" @click="verifyCodeGet(accountNo)">获取验证码</button>
						<em v-if="!verifyShow">{{verifyTime}}s</em>
					</div>
				</div>
				<!-- 已绑定手机号，验证手机号 -->
				<div class="bd" v-if="typeCode == 3 && typeAccount">
					<h1>验证账号</h1>
					<div class="txt"><span>手机号</span><input type="tel" placeholder="请输入手机号" v-model="accountNo"></div>
				</div>
				<div class="gz" v-if="regulation">
					<h1>券码规则</h1>
					<div v-html="regulation" class="tip"></div>
				</div>
			</div>
			<div class="foot">
				<!-- 直充手机号提交 -->
				<button @click="submit" :disabled="disabled" v-if="typeCode == 1">{{submitTxt}}</button>
				<!-- 卡密手机号提交 -->
				<button @click="submit" :disabled="disabled" v-if="typeCode == 3 && !typeAccount">{{submitTxt}}</button>
				<!-- 多账号类型充值提交 -->
				<button @click="submitTX" v-if="typeCode == 2" :disabled="disabled">{{submitTxt}}</button>
				<!-- 卡密类型，绑定了手机号，验证手机号按钮 -->
				<button class="submit" @click="verifyPhone" v-if="typeCode == 3 && typeAccount">{{submitTxt}}</button>
			</div>
		</div>
		<div class="use" v-if="status===1 || status===3">
			<div class="head">
				<header class="used">
					<div class="lt">
						<p>{{txt}}</p>
						<span>有效期至:{{expiredDate}}</span>
					</div>
				</header>
			</div>
			<div class="bd1">
				<div class="nodata">
					<img src="../assets/used.png" alt="电子券已使用">
					<p>电子券已使用</p>
				</div>
			</div>
		</div>
		<div class="use" v-if="status===4">
			<div class="head">
				<header class="used">
					<div class="lt">
						<p>{{txt}}</p>
						<span>有效期至:{{expiredDate}}</span>
					</div>
				</header>
			</div>
			<div class="bd1">
				<div class="nodata">
					<img src="../assets/outDate.png" alt="电子券已失效">
					<p>电子券已失效</p>
				</div>
			</div>
		</div>
		<div class="result" v-if="flag">
			<div class="dec">
				<img :src="srcDec" alt="成功">
				<p>{{dec}}</p>
			</div>
		</div>
		<div class="use_loading" v-if="loading">
			<div class="loading">
				<img src="../assets/loading.png" alt="加载中">
			</div>
		</div>
		<!--绑定手机号 -->
		<div class="pop" v-if="popVisible">
			<div class="win">
				<div class="box">
					<h1>手机号验证</h1>
					<!-- 绑定了手机号 -->
					<div class="txt" v-if="typeAccount" style="margin-bottom:40px"><span>手机号</span><input type="number" placeholder="输入手机号"
						v-model="mobile"></div>
						<!-- 未绑定手机号 -->
					<div class="txt" v-if="!typeAccount"><span>手机号</span><input type="number" placeholder="输入手机号" v-model="mobile"></div>
					<div class="form" v-if="!typeAccount">
						<div class="code">
							<span>验证码</span>
							<input type="text" placeholder="输入验证码" v-model="verifyCode">
						</div>
						<button v-if="verifyShow" @click="verifyCodeGet(mobile)">获取验证码</button>
						<em v-if="!verifyShow">{{verifyTime}}s</em>
					</div>
					<!-- 未绑定手机号 -->
					<button class="submit" @click="submitPhone" v-if="!typeAccount">确认</button>
					<!-- 绑定了手机号 -->
					<button class="submit" @click="submitVerifyPhone" v-if="typeAccount">确认</button>
				</div>
			</div>
		</div>
		<!-- 未生效弹出层 -->
		<div class="pop" v-if="takeVisible">
			<div class="win">
				<div class="box">
					<h4>电子券有效日期为：</h4>
					<label>生效时间：{{this.effectiveDate}} 00:00:00</label><br />
					<label>失效时间：{{this.expiredDate}} 23:59:59</label><br />
					<br />
					<label>温馨提示：本券码为特殊活动券，超过有效期券码会失效，失效券码请联系原购买渠道，若在有效期内无法使用请联系客服电话:0571-85199986</label>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				// 充值类型，1手机号直充，2多账号直充，3卡密
				typeCode:1,
				// 是否绑定手机号,默认未绑定
				typeAccount: false,
				txt: this.$route.query.txt,
				key: this.$route.query.key,
				imgUrl: this.$route.query.logo,
				accountNo: '',
				reAccountNo: '',
				flag: false,
				disabled: false,
				status: 0,
				submitTxt: '确认',
				dec: '',
				srcDec: require('../assets/success.png'),
				seconds: 5,
				loading: true,
				expiredDate: '',
				popVisible: false,
				amount: '',
				productId: '',
				chargeType: undefined,
				chargeAccountType: undefined,
				showType: undefined,
				verifyShow: true,
				visible: true,
				verifyCode: '',
				verifyTime: 60,
				mobile: '',
				qqAccount: '',
				productCategoryId: this.$route.query.productCategoryId,
				// 是否生效，未生效弹出层挡住
				takeVisible: false,
				effectiveDate: '',
				regulation: ''
			}
		},
		mounted() {
			document.title = '云之谷';
			this.getTicketStatus(this.key);
		},
		methods: {
			/**
			 * 卡密产品验证手机号
			 */
			verifyPhone() {
				if (this.accountNo === '') {
					// console.log('充值账户不能为空！');
					this.flag = true;
					this.srcDec = require('../assets/fail.png');
					this.dec = '手机号不能为空';
					setTimeout((() => {
						this.flag = false;
					}), 1000);
				} else {
					const obj = {
						// mobile:this.accountNo,
						ticketNo: this.key
					}
					this.disabled = true;
					this.$http.POST('productTicket/selectProductTicket', obj).then(res => {
						// this.flag = true;
						if (res.code === 0) {
							// this.starbuckKey = res.data.outTicketPsw;
							this.minus(1);
						} else {
							this.disabled = false;
							this.flag = true;
							this.submitTxt = '确认';
							this.srcDec = require('../assets/fail.png');
							this.dec = res.msg;
							setTimeout((() => {
								this.flag = false;
							}), 1000);
						}
					});
				}
			},
			/**
			 * 验证手机号
			 */
			submitVerifyPhone() {
				if (this.mobile === '') {
					// console.log('充值账户不能为空！');
					this.flag = true;
					this.srcDec = require('../assets/fail.png');
					this.dec = '手机号不能为空';
					setTimeout((() => {
						this.flag = false;
					}), 1000);
				} else {
					const obj = {
						mobile: this.mobile,
						ticketNo: this.key,
						isVerify: 1
					}
					// this.disabled = true;
					this.$http.POST('productTicket/selectProductTicket', obj).then(res => {
						// this.flag = true;
						if (res.code === 0) {
							this.flag = true;
							this.srcDec = require('../assets/success.png');
							this.dec = '验证成功';
							setTimeout((() => {
								this.flag = false;
							}), 1000);
							this.popVisible = false
						} else {
							this.flag = true;
							this.srcDec = require('../assets/fail.png');
							this.dec = res.msg;
							setTimeout((() => {
								this.flag = false;
							}), 1000);
						}
					});
				}
			},
			verifyCodeGet(mobile) {
				if (this.visible) {
					this.visible = false;
					this.$http.POST('sms/send', {
						accountNumber: mobile,
						type: 1
					}).then((res) => {
						this.flag = true;
						if (res.code === 0) {
							this.dec = '验证码发送成功';
							this.srcDec = require('../assets/success.png');
							setTimeout((() => {
								this.flag = false;
							}), 1000);
							this.verifyShow = false;
							const timer = setInterval(() => {
								this.verifyTime--;
								if (this.verifyTime <= 0) {
									this.verifyShow = true;
									this.visible = true;
									clearInterval(timer);
									this.verifyTime = 60;
								}
							}, 1000);
						} else {
							this.srcDec = require('../assets/fail.png');
							this.dec = '验证码发送失败';
							setTimeout((() => {
								this.flag = false;
							}), 1000);
						}
					});
				}
			},
			getTicketStatus(key) {
				const obj = {
					ticketNo: key,
					productCategoryId: this.productCategoryId
				};
				this.$http.POST('productTicket/selectProductTicket', obj).then(res => {
					this.loading = false;
					if (res.code === 0) {
						this.status = res.data.useStatus;
						this.amount = res.data.amount + '元';
						this.expiredDate = res.data.expiredDate;
						this.productId = res.data.productId
						this.qqAccount = res.data.mobile;
						this.regulation = res.data.regulation;
						// 充值类型，1直充，2卡密
						this.chargeType = res.data.productCategoryList[0].chargeType;
						// 充值账号类型 0手机号，1 QQ号, 2其他账号',
						this.chargeAccountType = res.data.productCategoryList[0].ChangeAccountType;
						// 显示类型：0都不是，1二维码，2兑换码, 3跳转链接
						this.showType = res.data.productCategoryList[0].showType;
						if(this.chargeType == 1 && this.chargeAccountType ==0){ // 手机号直充
							this.typeCode = 1
						}else if(this.chargeType == 1 && this.chargeAccountType!=0){ // 多账号直充
							this.typeCode = 2
							// 如果是可使用的电子券，且是直充类型，充值账号类型不是手机号的，弹出绑定手机号的框
							if(this.status == 0 || this.status==2){
								this.popVisible = true
							}
						}else if(this.chargeType == 2){ // 卡密产品
							this.typeCode = 3
						}
						if(this.qqAccount != ''){ // 如果已绑定手机号
							this.typeAccount = true
						}
						document.title = this.txt;
						// 获取生效日期
						this.effectiveDate = res.data.effectiveDate;
						let d = res.data.effectiveDate
						if (d.length === 10) { // 加上时分秒
							d = d + " 00:00:00";
						}
						// 如果未生效，弹出提示
						if (new Date().getTime() < new Date(d).getTime()) {
							this.takeVisible = true
						}
					} else {
						if (res.code === 2000) {
							this.$router.push({
								path: '/404'
							})
						} else {
							alert(res.msg);
						}
					}
				});
			},
			// 倒计时
			minus(isVerify) {
				var _this = this;
				_this.submitTxt = '充值中...' + _this.seconds + 's';
				var time = window.setInterval(function() {
					if (_this.seconds === 0) {
						_this.seconds = 5;
						window.clearInterval(time);
						if (_this.chargeType == 1) { // 直充
							_this.getOrderInfo(isVerify);
						} else if (_this.chargeType == 2) { // 卡密
							_this.getsecritOrderInfo(isVerify);
						}
					} else {
						_this.submitTxt = '充值中...' + _this.seconds + 's';
						_this.seconds -= 1
					}
				}, 1000)
			},
			/**
			 * 绑定手机号
			 */
			submitPhone() {
				const obj = {
					ticketNo: this.key,
					mobile: this.mobile,
					code: this.verifyCode,
					productCategoryId: this.productCategoryId
				}
				this.$http.POST('productTicket/bindMobile', obj).then(res => {
					if (res.code == 0) {
						this.flag = true;
						this.srcDec = require('../assets/success.png');
						this.dec = '验证成功';
						setTimeout((() => {
							this.flag = false;
						}), 1000);
						this.popVisible = false;
					} else {
						this.flag = true;
						this.srcDec = require('../assets/fail.png');
						this.dec = res.msg;
						setTimeout((() => {
							this.flag = false;
						}), 1000);
					}
				})
			},
			/**
			 * 直充，卡密，手机号提交
			 */
			submit() { 
				if (this.accountNo === '') {
					// console.log('充值账户不能为空！');
					this.flag = true;
					this.srcDec = require('../assets/fail.png');
					this.dec = '充值账户不能为空！';
					setTimeout((() => {
						this.flag = false;
					}), 1000);
				} else if (this.verifyCode === '') {
					// console.log('请再输一遍账户！');
					this.flag = true;
					this.srcDec = require('../assets/fail.png');
					this.dec = '请输入验证码！';
					setTimeout((() => {
						this.flag = false;
					}), 1000);
				} else {
					if (this.chargeType == 1) { // 直充
						this.direct()
					} else if (this.chargeType == 2) { // 卡密
						this.secrit()
					}
				}

			},
			/**
			 * 多账号直充
			 */
			submitTX() {
				if (this.accountNo === '') {
					// console.log('充值账户不能为空！');
					this.flag = true;
					this.srcDec = require('../assets/fail.png');
					this.dec = '请输入账号';
					setTimeout((() => {
						this.flag = false;
					}), 1000);
					return;
				}
				if (this.reAccountNo === '') {
					// console.log('请再输一遍账户！');
					this.flag = true;
					this.srcDec = require('../assets/fail.png');
					this.dec = '请再次输入账号';
					setTimeout((() => {
						this.flag = false;
					}), 1000);
					return;
				}
				if (this.accountNo !== this.reAccountNo) {
					this.flag = true;
					this.srcDec = require('../assets/fail.png');
					this.dec = '请输入相同的账号';
					setTimeout((() => {
						this.flag = false;
					}), 1000);
					return;
				} else {
					const obj = {
						accountNumber: this.accountNo,
						ticketNo: this.key,
						code: this.verifyCode,
						productCategoryId: this.productCategoryId
					}
					this.disabled = true;
					this.$http.POST('productTicket/rechargeProductTicket', obj).then(res => {
						// this.flag = true;
						if (res.code === 0) {
							// const customerOrderNo = res.data.customerOrderNo;
							this.minus('-1');
						} else {
							this.disabled = false;
							this.flag = true;
							this.submitTxt = '确认充值';
							this.srcDec = require('../assets/fail.png');
							this.dec = res.msg;
							setTimeout((() => {
								this.flag = false;
							}), 1000);
						}
					});
				}
			},
			/**
			 * 手机号直充提交
			 */
			direct() {
				const obj = {
					// productType:this.type,
					// buyNum:1,
					accountNumber: this.accountNo,
					ticketNo: this.key,
					code: this.verifyCode,
					productCategoryId: this.productCategoryId
				}
				this.disabled = true;
				this.$http.POST('productTicket/rechargeProductTicket', obj).then(res => {
					// this.flag = true;
					if (res.code === 0) {
						// const customerOrderNo = res.data.customerOrderNo;
						this.minus('-1');
					} else {
						this.disabled = false;
						this.flag = true;
						this.submitTxt = '确认充值';
						this.srcDec = require('../assets/fail.png');
						this.dec = res.msg;
						setTimeout((() => {
							this.flag = false;
						}), 1000);
					}
				});
			},
			secrit() { // 卡密提交
				const obj = {
					accountNumber: this.accountNo,
					ticketNo: this.key,
					code: this.verifyCode,
					productCategoryId: this.productCategoryId
				}
				this.disabled = true;
				this.$http.POST('productTicket/rechargeProductTicket', obj).then(res => {
					// this.flag = true;
					if (res.code === 0) {
						// const customerOrderNo = res.data.customerOrderNo;
						this.minus('-1');
					} else {
						this.disabled = false;
						this.flag = true;
						this.submitTxt = '确认';
						this.srcDec = require('../assets/fail.png');
						this.dec = res.msg;
						setTimeout((() => {
							this.flag = false;
						}), 1000);
					}
				});
			},
			/**
			 * @param {Object} isVerify 是否验证手机号，-1不验证拿卡密信息，1验证
			 */
			getsecritOrderInfo(isVerify) {
				const obj = {
					ticketNo: this.key,
					isVerify: isVerify,
					mobile: this.accountNo
				};
				this.$http.POST('productTicket/selectProductTicket', obj).then(res => {
					this.flag = true;
					this.submitTxt = '确认充值';
					if (res.code === 0) {
						this.dec = '充值成功';
						this.srcDec = require('../assets/success.png');
						this.status = 1;
						this.$router.push({
							path: '/kamiCode',
							query: {
								key: this.key,
								mobile: this.accountNo
							}
						})
					} else {
						this.disabled = false;
						this.srcDec = require('../assets/fail.png');
						this.dec = res.msg;
					}
					setTimeout((() => {
						this.flag = false;
					}), 2000);
				});
			},
			// 查询充值结果
			getOrderInfo(isVerify) {
				const obj = {
					ticketNo: this.key,
					isVerify: isVerify,
					mobile: this.accountNo
				};
				this.$http.POST('productTicket/selectProductTicket', obj).then(res => {
					this.flag = true;
					this.disabled = false;
					this.submitTxt = '确认充值';
					if (res.code == 0) {
						this.dec = '充值成功';
						this.status = 1;
						this.srcDec = require('../assets/success.png');
					} else {
						if (res.code === 3001) {
							this.dec = '充值成功';
							this.status = 1;
							this.srcDec = require('../assets/success.png');
						} else {
							this.srcDec = require('../assets/fail.png');
							this.dec = res.msg;
						}
					}
					setTimeout((() => {
						this.flag = false;
					}), 2000);
				});
			}
		}
	}
</script>
<style lang="scss" scoped>
	.wrapper {
		font-size: 16px;
		height: 100%;
		position: relative;

		.use {
			height: 100%;
			position: relative;

			.head_tip {
				background: #FEFCEC;
				padding: 10px;
				// line-height: 36px;
				font-size: 14px;
				color: #F76A24;
			}

			.head {
				height: 110px;
				background: #fff;
				padding: 10px 15px 15px 15px;
				box-sizing: border-box;

				header {
					height: 85px;
					background: url('../assets/recharge_bg.png') no-repeat;
					background-size: 345px 85px;
					position: relative;
					display: flex;

					// align-items: center;
					// flex-direction: column;
					span.ico {
						position: absolute;
						bottom: 0;
						left: 0;
						border-bottom-left-radius: 4px;
						border-top-right-radius: 7px;
						font-size: 15px;
						color: #fff;
						padding: 0 4px;
						background: linear-gradient(to right, #FF8E00, #FF5500);
					}

					span.tip {
						position: absolute;
						bottom: 0;
						left: 60px;
						font-size: 14px;
					}

					.lt {
						padding: 10px 0 0 15px;
						// float: left;
						flex: 1;

						p {
							font-size: 17px;
							color: #333333;
							font-weight: bold;
						}

						span {
							font-size: 14px;
							color: #333333;
							padding-top: 2px;
						}
					}

					.logo {
						padding: 35px 8.5px 0 0;
					}

					img {
						float: right;
						width: 60px;
						height: 60px;
						padding: 12.5px;
					}
				}

				header.used {
					background: url('../assets/used_bg.png') no-repeat;
					background-size: 345px 85px;
				}
			}

			.body {
				header {
					// height: 36px;
					background: #FEFCEC;
					padding: 10px;
					// line-height: 36px;
					font-size: 14px;
					color: #F76A24;
				}

				.bd {
					padding: 16px;

					h1 {
						font-size: 18px;
						font-weight: bold;
						color: #333333;
					}

					.txt {
						margin-top: 16px;
						background: #fff;
						height: 50px;
						line-height: 50px;
						padding: 0 10px;
						display: flex;
						align-items: center;

						input {
							flex: 1;
							border: none;
							background: none;
							text-align: right;
							padding: 10px 0;
							font-size: 16px;
						}
					}

					.form {
						margin-top: 16px;
						display: flex;
						align-items: center;

						.code {
							display: flex;
							background: #fff;
							margin-right: 10px;
							height: 50px;
							align-items: center;
							padding: 0 10px;
							width: 200px;

							span {
								flex: 1;
							}

							input {
								width: 108px;
								border: none;
								background: none;
								text-align: right;
								padding: 10px 0;
								font-size: 16px;
							}
						}

						button,
						em {
							color: #fff;
							width: 120px;
							height: 30px;
							line-height: 30px;
							background: linear-gradient(to right, #FF8C37, #FF7201);
							font-size: 15px;
							border-radius: 15px;
							text-align: center;
							font-style: normal;
						}

						em {
							background: #555555;
						}
					}
				}

				.ft {
					padding: 4px 16px 0 16px;
					font-size: 16px;
					color: #F76A24;
				}
			}

			.bd1 {
				display: flex;
				justify-content: center;
				align-items: center;

				.nodata {
					display: flex;
					flex-direction: column;
					justify-content: center;
					align-items: center;
					padding-top: 50px;

					img {
						width: 100px;
						height: 100px;
					}

					p {
						font-size: 17px;
						color: #555555;
						padding-top: 10px;
					}
				}

				.ft {
					padding: 4px 16px 0 16px;
					font-size: 16px;
					color: #888888;
				}
			}

			.foot {
				// position: absolute;
				// bottom: 0;
				padding: 70px 16px 16px 16px;
				display: flex;
				width: 100%;
				box-sizing: border-box;

				button {
					flex: 1;
					height: 60px;
					line-height: 60px;
					color: #fff;
					background: linear-gradient(to right, #F9AF2F, #F5881A);
					font-size: 17px;
					border-radius: 8px;
				}
			}
			
			.gz{
				padding: 24px 17px;
				background: #F3F3F3;
				h1{
					font-size: 20px;
					color: #333333;
					font-weight: bold;
				}
				.tip{
					color: #666666;
					font-size: 15px;
					line-height: 28px;
				}
				.caption{
					img{
						max-width:100%;
						padding:5px 0;
					}
					p{
						color: #666666;
						font-size: 15px;
						line-height: 28px;
					}
				}
			}
		}

		.result {
			position: fixed;
			width: 100%;
			height: 100%;
			left: 0;
			top: 0px;
			display: flex;
			justify-content: center;
			align-items: center;
			z-index: 999;

			.dec {
				min-width: 120px;
				height: 120px;
				background: rgba(58, 58, 58, 0.9);
				display: flex;
				align-items: center;
				justify-content: center;
				flex-direction: column;
				border-radius: 2px;
				padding: 0 10px;

				img {
					width: 36px;
					height: 36px;
					font-size: 14px;
				}

				p {
					font-size: 14px;
					color: #fff;
					padding-top: 8px;
				}
			}
		}

		.use_loading {
			position: absolute;
			height: 100%;
			width: 100%;
			z-index: 11;
			left: 0;
			top: 0;

			.loading {
				width: 100%;
				height: 100%;
				background: rgba(0, 0, 0, 0.5);
				display: flex;
				justify-content: center;
				align-items: center;

				img {
					width: 50px;
					height: 50px;
					animation: turn 1s linear infinite;
					margin: 100px auto;
				}

				@keyframes turn {
					0% {
						-webkit-transform: rotate(0deg);
					}

					25% {
						-webkit-transform: rotate(90deg);
					}

					50% {
						-webkit-transform: rotate(180deg);
					}

					75% {
						-webkit-transform: rotate(270deg);
					}

					100% {
						-webkit-transform: rotate(360deg);
					}
				}
			}
		}

		.pop {
			position: fixed;
			width: 100%;
			height: 100%;
			top: 0;
			left: 0;
			background: rgba(0, 0, 0, 0.5);
			display: flex;
			justify-content: center;
			align-items: center;

			.win {
				width: 325px;
				height: 350px;

				p {
					text-align: right;
					padding-bottom: 10px;

					i {
						display: inline-block;
						width: 31px;
						height: 31px;
						background: url('../assets/close.png') no-repeat;
						background-size: 31px 31px;
					}
				}

				.box {
					width: 100%;
					height: 310px;
					background: #F3F3F3;
					border-radius: 7px;
					padding: 30px 15px;
					box-sizing: border-box;

					.submit {
						margin: 30px 25px 0 25px;
						width: 245px;
						height: 44px;
						border-radius: 22px;
						color: #fff;
						font-size: 18px;
						font-weight: bolder;
						background: linear-gradient(to right, #FF9A4F, #FF7509);
					}
					.qqMusic {
						color: #F76A24;
						
						p {
							text-align: left;
						}
					}
					
					h1 {
						font-size: 18px;
						color: #333333;
						font-weight: bolder;
						padding-bottom: 16px;
					}

					.txt {
						margin-top: 16px;
						background: #fff;
						height: 50px;
						line-height: 50px;
						padding: 0 10px;
						display: flex;
						align-items: center;

						input {
							flex: 1;
							border: none;
							background: none;
							text-align: right;
							padding: 10px 0;
							font-size: 16px;
						}
					}

					.form {
						margin-top: 16px;
						display: flex;
						align-items: center;

						.code {
							display: flex;
							background: #fff;
							margin-right: 10px;
							height: 50px;
							align-items: center;
							padding: 0 10px;
							width: 200px;

							span {
								flex: 1;
							}

							input {
								width: 108px;
								border: none;
								background: none;
								text-align: right;
								padding: 10px 0;
								font-size: 16px;
							}
						}

						button,
						em {
							color: #fff;
							width: 120px;
							height: 30px;
							line-height: 30px;
							background: linear-gradient(to right, #FF8C37, #FF7201);
							font-size: 15px;
							border-radius: 15px;
							text-align: center;
							font-style: normal;
						}

						em {
							background: #555555;
						}
					}

					h4 {
						font-size: 18px;
						color: #FBB50B;
						font-weight: bolder;
						padding-bottom: 16px;
					}

					label {
						font-size: 16px;
						color: #FBB50B;
						font-weight: bolder;
						padding-bottom: 16px;
					}
				}
			}
		}
	}
</style>
